import { Component, Input } from '@angular/core';
import { EnvironmentService } from 'app/core/services/environment.service';
import { LicenseService } from '../../services/license.service';
import { RxComponent } from '../../../shared/components/common/rx.component';
import { CertificateService } from '../content/certificate/certificate.service';
import { ConfigService } from '../../services/config.service';

@Component({
    selector: 'itpx-exam-tile',
    templateUrl: './exam.component.html',
    styleUrls: ['./exam.component.css']
})
export class ExamComponent extends RxComponent {

    //private readonly BaseImageUrl = 'https://www.leapest.com/INTERSHOP/static/WFS/inSPIRED-inTRONICS_Business-Site/-/inSPIRED/en_US/';

    @Input()
    private assignment;
    private exam;
    private images: string[];
    private examResults;

    constructor(private envService: EnvironmentService,
                private service: LicenseService,
                private certificateService: CertificateService,
                private configService: ConfigService) {
        super();
        this.images = this.envService.config['server'].images;
    }

    ngOnInit() {
        this.exam = {};
        this.exam = {
            title: this.assignment.productVariant.name,
            imageUrl: this.assignment.productVariant.product.imageUrl,
            status: this.assignment.status,
            product: {
                certificateType: this.removeDashes(this.assignment.productVariant.certificateType),
                deliveryFormat: this.removeDashes(this.assignment.productVariant.deliveryFormat),
                language: this.assignment.productVariant.languageValue
            },
            learnerNotified: this.assignment.learnerNotified,
            fulfillmentData: null,
            address: null,
            date: null,
            timeZone: null
        }

        if (this.assignment.exam) {
            this.exam.address = this.assignment.exam.address;
            this.exam.date = this.assignment.exam.date;
            this.exam.timeZone = this.assignment.exam.timeZone;
            if (this.assignment.productVariant.examFulfillmentType !== 'Complete') {
                let turnAroundHours = this.assignment.productVariant.fulfillmentTurnAroundTime || 72;
                // let examMinDate = moment(tile.exam.date).add(turnAroundTimeDays, 'days')._d;

                this.exam.fulfillmentData = {
                    turnAroundTime: turnAroundHours,
                    date: this.assignment.exam.fulfillmentDeadlineDate
                };
            }
        }

        this.service.getExamResultsForVouchers([this.assignment.voucherNumber])
            .neverError()
            .map(body => body.data)
            .bindToLifecycle(this)
            .subscribe((vouchers = []) => {
                this.examResults = vouchers.find(v => v.voucher === this.assignment.voucherNumber);
            });
    }

    private removeDashes(val: string): string {
        return val ? val.replace('-', ' ') : null;
    }

    downloadCertificate() {
        const baseUrl = this.configService.get('server').sphinx + '/proxy/jwt/lib/';
        const { key, bucket } = this.examResults.certificate;
        const certificateUrl = `${baseUrl}/${bucket}/${key}`;
        this.certificateService.getCertificateFile(certificateUrl)
            .bindToLifecycle(this)
            .subscribe();
    }
}



// WEBPACK FOOTER //
// ./src/app/core/components/exam/exam.component.ts